import { useState } from "react";
import Modal from "../modal/modal";
import Nav from "./nav/nav";
import { FiCopy, FiCheck } from "react-icons/fi";
import "./sidebar.css";
import GridFinder from "./gridFinder/gridFinder";

function Sidebar({ advancedmode, updateStateField }) {
    const [isModelOpen, setModel] = useState(false);
    const copyButtonText = <><FiCopy className="icon-copy" /> Copy acknowledgement</>;
    const copiedButtonText = <>Copied!<FiCheck className="icon-check" /></>;
    const [buttonText, setButtonText] = useState(copyButtonText);
    const acknowledgementText = "The authors acknowledge the use of the Zonda service (https://zonda.ethz.ch/) for the preparation of external parameter data for the ICON model. Zonda has been developed and is maintained by the Center for Climate Systems Modeling (C2SM), ETH Zurich, in cooperation with the Federal Office for Meteorology and Climatology MeteoSwiss and Deutscher Wetterdienst (DWD).";
    const code = (<code>{acknowledgementText}</code>);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(acknowledgementText);
        setButtonText(copiedButtonText);
    };

    const openModal = () => {
        setButtonText(copyButtonText);
        setModel(true);
    };

    return (
        <div className="sidebar">
            <Nav advancedmode={advancedmode} />
            {isModelOpen && (
                <Modal
                    message={code}
                    closeModal={() => setModel(false)}
                    buttonAction={copyToClipboard}
                    buttonText={buttonText}
                />
            )}
            <button className="acknowledge-modal-toggle" onClick={openModal}>
                <p>📝 How to cite Zonda</p>
            </button>
            <GridFinder updateStateField={updateStateField} />
        </div>
    );
}

export default Sidebar;
